var routes = {};

(function() {
    /*
File generated by js-routes 1.4.9
Based on Rails 6.0.3 routes of Ujs::Application
 */

(function() {
  var DeprecatedGlobbingBehavior, NodeTypes, ParameterMissing, ReservedOptions, SpecialOptionsKey, UriEncoderSegmentRegex, Utils, result, root,
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  ParameterMissing = function(message, fileName, lineNumber) {
    var instance;
    instance = new Error(message, fileName, lineNumber);
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    } else {
      instance.__proto__ = this.__proto__;
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, ParameterMissing);
    }
    return instance;
  };

  ParameterMissing.prototype = Object.create(Error.prototype, {
    constructor: {
      value: Error,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ParameterMissing, Error);
  } else {
    ParameterMissing.__proto__ = Error;
  }

  NodeTypes = {"GROUP":1,"CAT":2,"SYMBOL":3,"OR":4,"STAR":5,"LITERAL":6,"SLASH":7,"DOT":8};

  DeprecatedGlobbingBehavior = false;

  SpecialOptionsKey = "_options";

  UriEncoderSegmentRegex = /[^a-zA-Z0-9\-\._~!\$&'\(\)\*\+,;=:@]/g;

  ReservedOptions = ['anchor', 'trailing_slash', 'subdomain', 'host', 'port', 'protocol'];

  Utils = {
    configuration: {
      prefix: "",
      default_url_options: {},
      special_options_key: "_options",
      serializer: null
    },
    default_serializer: function(object, prefix) {
      var element, i, j, key, len, prop, s;
      if (prefix == null) {
        prefix = null;
      }
      if (object == null) {
        return "";
      }
      if (!prefix && !(this.get_object_type(object) === "object")) {
        throw new Error("Url parameters should be a javascript hash");
      }
      s = [];
      switch (this.get_object_type(object)) {
        case "array":
          for (i = j = 0, len = object.length; j < len; i = ++j) {
            element = object[i];
            s.push(this.default_serializer(element, prefix + "[]"));
          }
          break;
        case "object":
          for (key in object) {
            if (!hasProp.call(object, key)) continue;
            prop = object[key];
            if ((prop == null) && (prefix != null)) {
              prop = "";
            }
            if (prop != null) {
              if (prefix != null) {
                key = prefix + "[" + key + "]";
              }
              s.push(this.default_serializer(prop, key));
            }
          }
          break;
        default:
          if (object != null) {
            s.push((encodeURIComponent(prefix.toString())) + "=" + (encodeURIComponent(object.toString())));
          }
      }
      if (!s.length) {
        return "";
      }
      return s.join("&");
    },
    serialize: function(object) {
      var custom_serializer;
      custom_serializer = this.configuration.serializer;
      if ((custom_serializer != null) && this.get_object_type(custom_serializer) === "function") {
        return custom_serializer(object);
      } else {
        return this.default_serializer(object);
      }
    },
    clean_path: function(path) {
      var last_index;
      path = path.split("://");
      last_index = path.length - 1;
      path[last_index] = path[last_index].replace(/\/+/g, "/");
      return path.join("://");
    },
    extract_options: function(number_of_params, args) {
      var last_el, options;
      last_el = args[args.length - 1];
      if ((args.length > number_of_params && last_el === void 0) || ((last_el != null) && "object" === this.get_object_type(last_el) && !this.looks_like_serialized_model(last_el))) {
        options = args.pop() || {};
        delete options[this.configuration.special_options_key];
        return options;
      } else {
        return {};
      }
    },
    looks_like_serialized_model: function(object) {
      return !object[this.configuration.special_options_key] && ("id" in object || "to_param" in object);
    },
    path_identifier: function(object) {
      var property;
      if (object === 0) {
        return "0";
      }
      if (!object) {
        return "";
      }
      property = object;
      if (this.get_object_type(object) === "object") {
        if ("to_param" in object) {
          if (object.to_param == null) {
            throw new ParameterMissing("Route parameter missing: to_param");
          }
          property = object.to_param;
        } else if ("id" in object) {
          if (object.id == null) {
            throw new ParameterMissing("Route parameter missing: id");
          }
          property = object.id;
        } else {
          property = object;
        }
        if (this.get_object_type(property) === "function") {
          property = property.call(object);
        }
      }
      return property.toString();
    },
    clone: function(obj) {
      var attr, copy, key;
      if ((obj == null) || "object" !== this.get_object_type(obj)) {
        return obj;
      }
      copy = obj.constructor();
      for (key in obj) {
        if (!hasProp.call(obj, key)) continue;
        attr = obj[key];
        copy[key] = attr;
      }
      return copy;
    },
    merge: function() {
      var tap, xs;
      xs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      tap = function(o, fn) {
        fn(o);
        return o;
      };
      if ((xs != null ? xs.length : void 0) > 0) {
        return tap({}, function(m) {
          var j, k, len, results, v, x;
          results = [];
          for (j = 0, len = xs.length; j < len; j++) {
            x = xs[j];
            results.push((function() {
              var results1;
              results1 = [];
              for (k in x) {
                v = x[k];
                results1.push(m[k] = v);
              }
              return results1;
            })());
          }
          return results;
        });
      }
    },
    normalize_options: function(parts, required_parts, default_options, actual_parameters) {
      var i, j, key, len, options, part, parts_options, result, route_parts, url_parameters, use_all_parts, value;
      options = this.extract_options(parts.length, actual_parameters);
      if (actual_parameters.length > parts.length) {
        throw new Error("Too many parameters provided for path");
      }
      use_all_parts = actual_parameters.length > required_parts.length;
      parts_options = {};
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        use_all_parts = true;
        if (this.indexOf(parts, key) >= 0) {
          parts_options[key] = value;
        }
      }
      options = this.merge(this.configuration.default_url_options, default_options, options);
      result = {};
      url_parameters = {};
      result['url_parameters'] = url_parameters;
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        value = options[key];
        if (this.indexOf(ReservedOptions, key) >= 0) {
          result[key] = value;
        } else {
          url_parameters[key] = value;
        }
      }
      route_parts = use_all_parts ? parts : required_parts;
      i = 0;
      for (j = 0, len = route_parts.length; j < len; j++) {
        part = route_parts[j];
        if (i < actual_parameters.length) {
          if (!parts_options.hasOwnProperty(part)) {
            url_parameters[part] = actual_parameters[i];
            ++i;
          }
        }
      }
      return result;
    },
    build_route: function(parts, required_parts, default_options, route, full_url, args) {
      var options, parameters, result, url, url_params;
      args = Array.prototype.slice.call(args);
      options = this.normalize_options(parts, required_parts, default_options, args);
      parameters = options['url_parameters'];
      result = "" + (this.get_prefix()) + (this.visit(route, parameters));
      url = Utils.clean_path(result);
      if (options['trailing_slash'] === true) {
        url = url.replace(/(.*?)[\/]?$/, "$1/");
      }
      if ((url_params = this.serialize(parameters)).length) {
        url += "?" + url_params;
      }
      url += options.anchor ? "#" + options.anchor : "";
      if (full_url) {
        url = this.route_url(options) + url;
      }
      return url;
    },
    visit: function(route, parameters, optional) {
      var left, left_part, right, right_part, type, value;
      if (optional == null) {
        optional = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return this.visit(left, parameters, true);
        case NodeTypes.STAR:
          return this.visit_globbing(left, parameters, true);
        case NodeTypes.LITERAL:
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
          return left;
        case NodeTypes.CAT:
          left_part = this.visit(left, parameters, optional);
          right_part = this.visit(right, parameters, optional);
          if (optional && ((this.is_optional_node(left[0]) && !left_part) || ((this.is_optional_node(right[0])) && !right_part))) {
            return "";
          }
          return "" + left_part + right_part;
        case NodeTypes.SYMBOL:
          value = parameters[left];
          delete parameters[left];
          if (value != null) {
            return this.encode_segment(this.path_identifier(value));
          }
          if (optional) {
            return "";
          } else {
            throw new ParameterMissing("Route parameter missing: " + left);
          }
          break;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    encode_segment: function(segment) {
      return segment.replace(UriEncoderSegmentRegex, function(str) {
        return encodeURIComponent(str);
      });
    },
    is_optional_node: function(node) {
      return this.indexOf([NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT], node) >= 0;
    },
    build_path_spec: function(route, wildcard) {
      var left, right, type;
      if (wildcard == null) {
        wildcard = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return "(" + (this.build_path_spec(left)) + ")";
        case NodeTypes.CAT:
          return "" + (this.build_path_spec(left)) + (this.build_path_spec(right));
        case NodeTypes.STAR:
          return this.build_path_spec(left, true);
        case NodeTypes.SYMBOL:
          if (wildcard === true) {
            return "" + (left[0] === '*' ? '' : '*') + left;
          } else {
            return ":" + left;
          }
          break;
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
        case NodeTypes.LITERAL:
          return left;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    visit_globbing: function(route, parameters, optional) {
      var left, right, type, value;
      type = route[0], left = route[1], right = route[2];
      value = parameters[left];
      delete parameters[left];
      if (value == null) {
        return this.visit(route, parameters, optional);
      }
      value = (function() {
        switch (this.get_object_type(value)) {
          case "array":
            return value.join("/");
          default:
            return value;
        }
      }).call(this);
      if (DeprecatedGlobbingBehavior) {
        return this.path_identifier(value);
      } else {
        return encodeURI(this.path_identifier(value));
      }
    },
    get_prefix: function() {
      var prefix;
      prefix = this.configuration.prefix;
      if (prefix !== "") {
        prefix = (prefix.match("/$") ? prefix : prefix + "/");
      }
      return prefix;
    },
    route: function(parts_table, default_options, route_spec, full_url) {
      var j, len, part, parts, path_fn, ref, required, required_parts;
      required_parts = [];
      parts = [];
      for (j = 0, len = parts_table.length; j < len; j++) {
        ref = parts_table[j], part = ref[0], required = ref[1];
        parts.push(part);
        if (required) {
          required_parts.push(part);
        }
      }
      path_fn = function() {
        return Utils.build_route(parts, required_parts, default_options, route_spec, full_url, arguments);
      };
      path_fn.required_params = required_parts;
      path_fn.toString = function() {
        return Utils.build_path_spec(route_spec);
      };
      return path_fn;
    },
    route_url: function(route_defaults) {
      var hostname, port, protocol, subdomain;
      if (typeof route_defaults === 'string') {
        return route_defaults;
      }
      hostname = route_defaults.host || Utils.current_host();
      if (!hostname) {
        return '';
      }
      subdomain = route_defaults.subdomain ? route_defaults.subdomain + '.' : '';
      protocol = route_defaults.protocol || Utils.current_protocol();
      port = route_defaults.port || (!route_defaults.host ? Utils.current_port() : void 0);
      port = port ? ":" + port : '';
      return protocol + "://" + subdomain + hostname + port;
    },
    has_location: function() {
      return (typeof window !== "undefined" && window !== null ? window.location : void 0) != null;
    },
    current_host: function() {
      if (this.has_location()) {
        return window.location.hostname;
      } else {
        return null;
      }
    },
    current_protocol: function() {
      if (this.has_location() && window.location.protocol !== '') {
        return window.location.protocol.replace(/:$/, '');
      } else {
        return 'http';
      }
    },
    current_port: function() {
      if (this.has_location() && window.location.port !== '') {
        return window.location.port;
      } else {
        return '';
      }
    },
    _classToTypeCache: null,
    _classToType: function() {
      var j, len, name, ref;
      if (this._classToTypeCache != null) {
        return this._classToTypeCache;
      }
      this._classToTypeCache = {};
      ref = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
      for (j = 0, len = ref.length; j < len; j++) {
        name = ref[j];
        this._classToTypeCache["[object " + name + "]"] = name.toLowerCase();
      }
      return this._classToTypeCache;
    },
    get_object_type: function(obj) {
      if (root.jQuery && (root.jQuery.type != null)) {
        return root.jQuery.type(obj);
      }
      if (obj == null) {
        return "" + obj;
      }
      if (typeof obj === "object" || typeof obj === "function") {
        return this._classToType()[Object.prototype.toString.call(obj)] || "object";
      } else {
        return typeof obj;
      }
    },
    indexOf: function(array, element) {
      if (Array.prototype.indexOf) {
        return array.indexOf(element);
      } else {
        return this.indexOfImplementation(array, element);
      }
    },
    indexOfImplementation: function(array, element) {
      var el, i, j, len, result;
      result = -1;
      for (i = j = 0, len = array.length; j < len; i = ++j) {
        el = array[i];
        if (el === element) {
          result = i;
        }
      }
      return result;
    },
    namespace: function(root, namespace, routes) {
      var index, j, len, part, parts;
      parts = namespace ? namespace.split(".") : [];
      if (parts.length === 0) {
        return routes;
      }
      for (index = j = 0, len = parts.length; j < len; index = ++j) {
        part = parts[index];
        if (index < parts.length - 1) {
          root = (root[part] || (root[part] = {}));
        } else {
          return root[part] = routes;
        }
      }
    },
    configure: function(new_config) {
      return this.configuration = this.merge(this.configuration, new_config);
    },
    config: function() {
      return this.clone(this.configuration);
    },
    make: function() {
      var routes;
      routes = {
// admin_comment => /admin/comments/:id(.:format)
  // function(id, options)
  admin_comment_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"comments",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_comments => /admin/comments(.:format)
  // function(options)
  admin_comments_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"comments",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_email => /admin/emails/:id(.:format)
  // function(id, options)
  admin_email_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"emails",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_emails => /admin/emails(.:format)
  // function(options)
  admin_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_employer => /admin/employers/:id(.:format)
  // function(id, options)
  admin_employer_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_employer_credit_purchase => /admin/employers/:employer_id/credit_purchases/:id(.:format)
  // function(employer_id, id, options)
  admin_employer_credit_purchase_path: Utils.route([["employer_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"employer_id",false],[2,[7,"/",false],[2,[6,"credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// admin_employer_credit_purchases => /admin/employers/:employer_id/credit_purchases(.:format)
  // function(employer_id, options)
  admin_employer_credit_purchases_path: Utils.route([["employer_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"employer_id",false],[2,[7,"/",false],[2,[6,"credit_purchases",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// admin_employers => /admin/employers(.:format)
  // function(options)
  admin_employers_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_highrise_people_search => /admin/highrise/people_search(.:format)
  // function(options)
  admin_highrise_people_search_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"highrise",false],[2,[7,"/",false],[2,[6,"people_search",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_job_listing => /admin/job_listings/:id(.:format)
  // function(id, options)
  admin_job_listing_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_listings",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_job_listings => /admin/job_listings(.:format)
  // function(options)
  admin_job_listings_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_listings",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_job_seeker => /admin/job_seekers/:id(.:format)
  // function(id, options)
  admin_job_seeker_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_seekers",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_job_seekers => /admin/job_seekers(.:format)
  // function(options)
  admin_job_seekers_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_seekers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_overview => /admin/overview(.:format)
  // function(options)
  admin_overview_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"overview",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_portfolio => /admin/portfolios/:id(.:format)
  // function(id, options)
  admin_portfolio_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"portfolios",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_portfolios => /admin/portfolios(.:format)
  // function(options)
  admin_portfolios_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"portfolios",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_setting => /admin/settings/:id(.:format)
  // function(id, options)
  admin_setting_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"settings",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_settings => /admin/settings(.:format)
  // function(options)
  admin_settings_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"settings",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_stats => /admin/overview/stats(.:format)
  // function(options)
  admin_stats_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"overview",false],[2,[7,"/",false],[2,[6,"stats",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// auto_renew_job_listing => /listings/:id/auto_renew(.:format)
  // function(id, options)
  auto_renew_job_listing_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"auto_renew",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// blog_2010_08_introduction_urology_job_search => /blog/2010/08/introduction-urology-job-search(.:format)
  // function(options)
  blog_2010_08_introduction_urology_job_search_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"08",false],[2,[7,"/",false],[2,[6,"introduction-urology-job-search",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2010_09_credentialing_2_ways_keep_track_your_paperwork => /blog/2010/09/credentialing-2-ways-keep-track-your-paperwork(.:format)
  // function(options)
  blog_2010_09_credentialing_2_ways_keep_track_your_paperwork_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"09",false],[2,[7,"/",false],[2,[6,"credentialing-2-ways-keep-track-your-paperwork",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2010_10_earning_additional_income_through_military_service => /blog/2010/10/earning-additional-income-through-military-service(.:format)
  // function(options)
  blog_2010_10_earning_additional_income_through_military_service_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"10",false],[2,[7,"/",false],[2,[6,"earning-additional-income-through-military-service",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2010_11_hca_stipend_program => /blog/2010/11/hca-stipend-program(.:format)
  // function(options)
  blog_2010_11_hca_stipend_program_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"11",false],[2,[7,"/",false],[2,[6,"hca-stipend-program",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2010_11_medical_licensing_start_early => /blog/2010/11/medical-licensing-start-early(.:format)
  // function(options)
  blog_2010_11_medical_licensing_start_early_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"11",false],[2,[7,"/",false],[2,[6,"medical-licensing-start-early",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2010_12_luggage_interview_season_skyroll => /blog/2010/12/luggage-interview-season-skyroll(.:format)
  // function(options)
  blog_2010_12_luggage_interview_season_skyroll_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2010",false],[2,[7,"/",false],[2,[6,"12",false],[2,[7,"/",false],[2,[6,"luggage-interview-season-skyroll",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_01_busier_usual_lately => /blog/2011/01/busier-usual-lately(.:format)
  // function(options)
  blog_2011_01_busier_usual_lately_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"01",false],[2,[7,"/",false],[2,[6,"busier-usual-lately",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_02_middle_men_who_are_players_recruiting_business => /blog/2011/02/middle-men-who-are-players-recruiting-business(.:format)
  // function(options)
  blog_2011_02_middle_men_who_are_players_recruiting_business_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"02",false],[2,[7,"/",false],[2,[6,"middle-men-who-are-players-recruiting-business",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_03_new_feature_employer_pages => /blog/2011/03/new-feature-employer-pages(.:format)
  // function(options)
  blog_2011_03_new_feature_employer_pages_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"03",false],[2,[7,"/",false],[2,[6,"new-feature-employer-pages",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_04_leave_cysto_cart_behind => /blog/2011/04/leave-cysto-cart-behind(.:format)
  // function(options)
  blog_2011_04_leave_cysto_cart_behind_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"04",false],[2,[7,"/",false],[2,[6,"leave-cysto-cart-behind",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_04_picture_pages => /blog/2011/04/picture-pages(.:format)
  // function(options)
  blog_2011_04_picture_pages_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"04",false],[2,[7,"/",false],[2,[6,"picture-pages",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_04_urology_job_search_reception_aua_annual_meeting => /blog/2011/04/urology-job-search-reception-aua-annual-meeting(.:format)
  // function(options)
  blog_2011_04_urology_job_search_reception_aua_annual_meeting_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"04",false],[2,[7,"/",false],[2,[6,"urology-job-search-reception-aua-annual-meeting",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_05_announcing_our_best_giveaway_yet_pocket_guide_urology => /blog/2011/05/announcing-our-best-giveaway-yet-pocket-guide-urology(.:format)
  // function(options)
  blog_2011_05_announcing_our_best_giveaway_yet_pocket_guide_urology_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"05",false],[2,[7,"/",false],[2,[6,"announcing-our-best-giveaway-yet-pocket-guide-urology",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_05_two_events_check_out_aua_annual_meeting => /blog/2011/05/two-events-check-out-aua-annual-meeting(.:format)
  // function(options)
  blog_2011_05_two_events_check_out_aua_annual_meeting_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"05",false],[2,[7,"/",false],[2,[6,"two-events-check-out-aua-annual-meeting",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_06_urology_congo => /blog/2011/06/urology-congo(.:format)
  // function(options)
  blog_2011_06_urology_congo_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"06",false],[2,[7,"/",false],[2,[6,"urology-congo",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_07_perfect_urology_job => /blog/2011/07/perfect-urology-job(.:format)
  // function(options)
  blog_2011_07_perfect_urology_job_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"07",false],[2,[7,"/",false],[2,[6,"perfect-urology-job",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_08_urotoday => /blog/2011/08/urotoday(.:format)
  // function(options)
  blog_2011_08_urotoday_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"08",false],[2,[7,"/",false],[2,[6,"urotoday",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_2011_09_residents_night_out_south_central_section_aua_sept_16th => /blog/2011/09/residents-night-out-south-central-section-aua-sept-16th(.:format)
  // function(options)
  blog_2011_09_residents_night_out_south_central_section_aua_sept_16th_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"2011",false],[2,[7,"/",false],[2,[6,"09",false],[2,[7,"/",false],[2,[6,"residents-night-out-south-central-section-aua-sept-16th",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_post => /blog/:id(.:format)
  // function(id, options)
  blog_post_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// blog_post_blog_comment => /blog/:blog_post_id/blog_comments/:id(.:format)
  // function(blog_post_id, id, options)
  blog_post_blog_comment_path: Utils.route([["blog_post_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"blog_post_id",false],[2,[7,"/",false],[2,[6,"blog_comments",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// blog_post_blog_comments => /blog/:blog_post_id/blog_comments(.:format)
  // function(blog_post_id, options)
  blog_post_blog_comments_path: Utils.route([["blog_post_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"blog_post_id",false],[2,[7,"/",false],[2,[6,"blog_comments",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// blog_posts => /blog(.:format)
  // function(options)
  blog_posts_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// contact => /contact(.:format)
  // function(options)
  contact_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// edit_admin_comment => /admin/comments/:id/edit(.:format)
  // function(id, options)
  edit_admin_comment_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"comments",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_email => /admin/emails/:id/edit(.:format)
  // function(id, options)
  edit_admin_email_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"emails",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_employer => /admin/employers/:id/edit(.:format)
  // function(id, options)
  edit_admin_employer_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_employer_credit_purchase => /admin/employers/:employer_id/credit_purchases/:id/edit(.:format)
  // function(employer_id, id, options)
  edit_admin_employer_credit_purchase_path: Utils.route([["employer_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"employer_id",false],[2,[7,"/",false],[2,[6,"credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// edit_admin_job_listing => /admin/job_listings/:id/edit(.:format)
  // function(id, options)
  edit_admin_job_listing_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_listings",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_job_seeker => /admin/job_seekers/:id/edit(.:format)
  // function(id, options)
  edit_admin_job_seeker_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_seekers",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_overview => /admin/overview/edit(.:format)
  // function(options)
  edit_admin_overview_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"overview",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_admin_portfolio => /admin/portfolios/:id/edit(.:format)
  // function(id, options)
  edit_admin_portfolio_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"portfolios",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_setting => /admin/settings/:id/edit(.:format)
  // function(id, options)
  edit_admin_setting_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"settings",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_blog_post => /blog/:id/edit(.:format)
  // function(id, options)
  edit_blog_post_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_blog_post_blog_comment => /blog/:blog_post_id/blog_comments/:id/edit(.:format)
  // function(blog_post_id, id, options)
  edit_blog_post_blog_comment_path: Utils.route([["blog_post_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"blog_post_id",false],[2,[7,"/",false],[2,[6,"blog_comments",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_contact => /contact/edit(.:format)
  // function(options)
  edit_contact_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// edit_employer => /employer/edit(.:format)
  // function(options)
  edit_employer_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"employer",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// edit_employer_page => /employers/:id/edit(.:format)
  // function(id, options)
  edit_employer_page_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_job_listing => /listings/:id/edit(.:format)
  // function(id, options)
  edit_job_listing_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_job_listing_job_listing_response => /listings/:job_listing_id/job_listing_responses/:id/edit(.:format)
  // function(job_listing_id, id, options)
  edit_job_listing_job_listing_response_path: Utils.route([["job_listing_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"job_listing_responses",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_job_listing_publishing_credit_usage => /listings/:job_listing_id/publishing_credit_usages/:id/edit(.:format)
  // function(job_listing_id, id, options)
  edit_job_listing_publishing_credit_usage_path: Utils.route([["job_listing_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"publishing_credit_usages",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_password_reset => /password_resets/:id/edit(.:format)
  // function(id, options)
  edit_password_reset_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_profile => /profile/edit(.:format)
  // function(options)
  edit_profile_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"profile",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// edit_publishing_credit_purchase => /publishing_credit_purchases/:id/edit(.:format)
  // function(id, options)
  edit_publishing_credit_purchase_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_rails_conductor_inbound_email => /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
  // function(id, options)
  edit_rails_conductor_inbound_email_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"conductor",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// edit_signup => /signup/edit(.:format)
  // function(options)
  edit_signup_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"signup",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// edit_user_session => /user_session/edit(.:format)
  // function(options)
  edit_user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user_session",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// employer => /employer(.:format)
  // function(options)
  employer_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"employer",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// employer_page => /employers/:id(.:format)
  // function(id, options)
  employer_page_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// employer_pages => /employers(.:format)
  // function(options)
  employer_pages_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"employers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// ipn_notify_publishing_credit_purchase => /publishing_credit_purchases/:id/ipn_notify(.:format)
  // function(id, options)
  ipn_notify_publishing_credit_purchase_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"ipn_notify",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// job_listing => /listings/:id(.:format)
  // function(id, options)
  job_listing_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// job_listing_job_listing_response => /listings/:job_listing_id/job_listing_responses/:id(.:format)
  // function(job_listing_id, id, options)
  job_listing_job_listing_response_path: Utils.route([["job_listing_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"job_listing_responses",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// job_listing_job_listing_responses => /listings/:job_listing_id/job_listing_responses(.:format)
  // function(job_listing_id, options)
  job_listing_job_listing_responses_path: Utils.route([["job_listing_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"job_listing_responses",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// job_listing_publishing_credit_usage => /listings/:job_listing_id/publishing_credit_usages/:id(.:format)
  // function(job_listing_id, id, options)
  job_listing_publishing_credit_usage_path: Utils.route([["job_listing_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"publishing_credit_usages",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// job_listing_publishing_credit_usages => /listings/:job_listing_id/publishing_credit_usages(.:format)
  // function(job_listing_id, options)
  job_listing_publishing_credit_usages_path: Utils.route([["job_listing_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"publishing_credit_usages",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// job_listings => /listings(.:format)
  // function(options)
  job_listings_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// job_seeker_portfolio => /job_seeker_portfolios/:id(.:format)
  // function(id, options)
  job_seeker_portfolio_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"job_seeker_portfolios",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// job_seeker_portfolios => /job_seeker_portfolios(.:format)
  // function(options)
  job_seeker_portfolios_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"job_seeker_portfolios",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// login => /login(.:format)
  // function(options)
  login_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"login",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// logout => /logout(.:format)
  // function(options)
  logout_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"logout",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// new_admin_comment => /admin/comments/new(.:format)
  // function(options)
  new_admin_comment_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"comments",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_email => /admin/emails/new(.:format)
  // function(options)
  new_admin_email_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"emails",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_employer => /admin/employers/new(.:format)
  // function(options)
  new_admin_employer_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_employer_credit_purchase => /admin/employers/:employer_id/credit_purchases/new(.:format)
  // function(employer_id, options)
  new_admin_employer_credit_purchase_path: Utils.route([["employer_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[3,"employer_id",false],[2,[7,"/",false],[2,[6,"credit_purchases",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// new_admin_job_listing => /admin/job_listings/new(.:format)
  // function(options)
  new_admin_job_listing_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_listings",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_job_seeker => /admin/job_seekers/new(.:format)
  // function(options)
  new_admin_job_seeker_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"job_seekers",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_overview => /admin/overview/new(.:format)
  // function(options)
  new_admin_overview_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"overview",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_portfolio => /admin/portfolios/new(.:format)
  // function(options)
  new_admin_portfolio_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"portfolios",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_setting => /admin/settings/new(.:format)
  // function(options)
  new_admin_setting_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"settings",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_blog_post => /blog/new(.:format)
  // function(options)
  new_blog_post_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_blog_post_blog_comment => /blog/:blog_post_id/blog_comments/new(.:format)
  // function(blog_post_id, options)
  new_blog_post_blog_comment_path: Utils.route([["blog_post_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"blog_post_id",false],[2,[7,"/",false],[2,[6,"blog_comments",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_contact => /contact/new(.:format)
  // function(options)
  new_contact_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_employer => /employer/new(.:format)
  // function(options)
  new_employer_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"employer",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_employer_page => /employers/new(.:format)
  // function(options)
  new_employer_page_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"employers",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_job_listing => /listings/new(.:format)
  // function(options)
  new_job_listing_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_job_listing_job_listing_response => /listings/:job_listing_id/job_listing_responses/new(.:format)
  // function(job_listing_id, options)
  new_job_listing_job_listing_response_path: Utils.route([["job_listing_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"job_listing_responses",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_job_listing_publishing_credit_usage => /listings/:job_listing_id/publishing_credit_usages/new(.:format)
  // function(job_listing_id, options)
  new_job_listing_publishing_credit_usage_path: Utils.route([["job_listing_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"listings",false],[2,[7,"/",false],[2,[3,"job_listing_id",false],[2,[7,"/",false],[2,[6,"publishing_credit_usages",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_password_reset => /password_resets/new(.:format)
  // function(options)
  new_password_reset_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_profile => /profile/new(.:format)
  // function(options)
  new_profile_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"profile",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_publishing_credit_purchase => /publishing_credit_purchases/new(.:format)
  // function(options)
  new_publishing_credit_purchase_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_rails_conductor_inbound_email => /rails/conductor/action_mailbox/inbound_emails/new(.:format)
  // function(options)
  new_rails_conductor_inbound_email_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"conductor",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// new_signup => /signup/new(.:format)
  // function(options)
  new_signup_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"signup",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_user_session => /user_session/new(.:format)
  // function(options)
  new_user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user_session",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// page => /:path(.:format)
  // function(path, options)
  page_path: Utils.route([["path",true],["format",false]], {}, [2,[7,"/",false],[2,[3,"path",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// password_reset => /password_resets/:id(.:format)
  // function(id, options)
  password_reset_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// password_resets => /password_resets(.:format)
  // function(options)
  password_resets_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// pay_with_paypal_publishing_credit_purchase => /publishing_credit_purchases/:id/pay_with_paypal(.:format)
  // function(id, options)
  pay_with_paypal_publishing_credit_purchase_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"pay_with_paypal",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// paypal_return_publishing_credit_purchase => /publishing_credit_purchases/:id/paypal_return(.:format)
  // function(id, options)
  paypal_return_publishing_credit_purchase_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"paypal_return",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// profile => /profile(.:format)
  // function(options)
  profile_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"profile",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// publishing_credit_purchase => /publishing_credit_purchases/:id(.:format)
  // function(id, options)
  publishing_credit_purchase_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// publishing_credit_purchases => /publishing_credit_purchases(.:format)
  // function(options)
  publishing_credit_purchases_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"publishing_credit_purchases",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// rails_blob_representation => /rails/active_storage/representations/:signed_blob_id/:variation_key/*filename(.:format)
  // function(signed_blob_id, variation_key, filename, options)
  rails_blob_representation_path: Utils.route([["signed_blob_id",true],["variation_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"representations",false],[2,[7,"/",false],[2,[3,"signed_blob_id",false],[2,[7,"/",false],[2,[3,"variation_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// rails_conductor_inbound_email => /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
  // function(id, options)
  rails_conductor_inbound_email_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"conductor",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_conductor_inbound_email_reroute => /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
  // function(inbound_email_id, options)
  rails_conductor_inbound_email_reroute_path: Utils.route([["inbound_email_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"conductor",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[3,"inbound_email_id",false],[2,[7,"/",false],[2,[6,"reroute",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_conductor_inbound_emails => /rails/conductor/action_mailbox/inbound_emails(.:format)
  // function(options)
  rails_conductor_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"conductor",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_direct_uploads => /rails/active_storage/direct_uploads(.:format)
  // function(options)
  rails_direct_uploads_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"direct_uploads",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// rails_disk_service => /rails/active_storage/disk/:encoded_key/*filename(.:format)
  // function(encoded_key, filename, options)
  rails_disk_service_path: Utils.route([["encoded_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_mailgun_inbound_emails => /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
  // function(options)
  rails_mailgun_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"mailgun",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[2,[7,"/",false],[2,[6,"mime",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_mandrill_inbound_emails => /rails/action_mailbox/mandrill/inbound_emails(.:format)
  // function(options)
  rails_mandrill_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"mandrill",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_mandrill_inbound_health_check => /rails/action_mailbox/mandrill/inbound_emails(.:format)
  // function(options)
  rails_mandrill_inbound_health_check_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"mandrill",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_postmark_inbound_emails => /rails/action_mailbox/postmark/inbound_emails(.:format)
  // function(options)
  rails_postmark_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"postmark",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_relay_inbound_emails => /rails/action_mailbox/relay/inbound_emails(.:format)
  // function(options)
  rails_relay_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"relay",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_sendgrid_inbound_emails => /rails/action_mailbox/sendgrid/inbound_emails(.:format)
  // function(options)
  rails_sendgrid_inbound_emails_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"action_mailbox",false],[2,[7,"/",false],[2,[6,"sendgrid",false],[2,[7,"/",false],[2,[6,"inbound_emails",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_service_blob => /rails/active_storage/blobs/:signed_id/*filename(.:format)
  // function(signed_id, filename, options)
  rails_service_blob_path: Utils.route([["signed_id",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"blobs",false],[2,[7,"/",false],[2,[3,"signed_id",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// root => /
  // function(options)
  root_path: Utils.route([], {}, [7,"/",false]),
// signup => /signup(.:format)
  // function(options)
  signup_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"signup",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// update_rails_disk_service => /rails/active_storage/disk/:encoded_token(.:format)
  // function(encoded_token, options)
  update_rails_disk_service_path: Utils.route([["encoded_token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_token",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user => /user(.:format)
  // function(options)
  user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// user_session => /user_session(.:format)
  // function(options)
  user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user_session",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// user_verification => /user_verifications/:id(.:format)
  // function(id, options)
  user_verification_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"user_verifications",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]])}
;
      routes.configure = function(config) {
        return Utils.configure(config);
      };
      routes.config = function() {
        return Utils.config();
      };
      Object.defineProperty(routes, 'defaults', {
        get: function() {
          throw new Error("Namespace" + ".defaults is removed. Use " + "Namespace" + ".configure() instead.");
        },
        set: function(value) {}
      });
      routes.default_serializer = function(object, prefix) {
        return Utils.default_serializer(object, prefix);
      };
      return Utils.namespace(root, "Namespace", routes);
    }
  };

  result = Utils.make();

  if (typeof define === "function" && define.amd) {
    define([], function() {
      return result;
    });
  }

  return result;

}).call(this);

}.call(routes));

export default routes.Namespace;